import withStyles from '@material-ui/core/styles/withStyles'
import ddLogo from 'root/src/client/public/DDlogoWhiteBigTransparent.png'
import moment from 'moment'
import React, { useEffect } from 'react'
import Link from 'root/src/client/web/base/Link'
import socialMedia from 'root/src/shared/constants/socialMedia'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiscord } from '@fortawesome/free-brands-svg-icons/faDiscord'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { ourEmail } from 'root/src/shared/constants/mail'
import { Logo } from 'root/src/client/web/base/Logo'

const style = {
	root: {
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
	},
	text: {
		padding: 10,
		textAlign: 'center',
		fontSize: 20,
	},
	spacer: {
		height: 150,
	},
}

const TechIssueComponent = ({ classes, timestamp }) => {
	useEffect(() => {
		const interval = setInterval(() => {
			handleRefresh()
		}, 10_000)
		return () => {
			clearInterval(interval)
		}
	})

	const handleRefresh = () => {
		window.location.reload()
	}

	return (
		<div className={classes.root}>
			<nav
				style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingBlock: 10, paddingInline: 20 }}
			>
				<Logo />
			</nav>
			<img className="my-2" src={ddLogo.src} alt="ddLogo" />
			<p className={classes.text}>
				We're experiencing technical difficulties (as of {moment(timestamp).format('h:mmA')})
			</p>
			<p className={classes.text}>
				Please try refreshing the page or check back later.
			</p>
			<p className={classes.text}>
				<button
					type="button"
					className="underline text-link"
					onClick={handleRefresh}
				>
					Click here to refresh the page
				</button>
			</p>
			<p className={classes.text}>
				If the issue persists, feel free to reach out to us via
				<div className="flex gap-2 mt-2 justify-center">
					<a
						className="underline text-link bg-primary rounded-full size-12 flex flex-initial justify-center items-center"
						href={`mailto:${ourEmail}`}
					>
						<FontAwesomeIcon icon={faEnvelope} size="lg" />
					</a>
					<Link
						href={socialMedia.discord}
						target="_blank"
						rel="noopener noreferrer"
						className="underline text-link bg-primary rounded-full size-12 flex flex-initial justify-center items-center"
					>
						<FontAwesomeIcon icon={faDiscord} size="lg" />
					</Link>
				</div>
			</p>
			<div className={classes.spacer} />
		</div>
	)
}

export default withStyles(style, { name: 'MuiTechIssueComponent' })(TechIssueComponent)
